const KeenSlider = window.KeenSlider

const { setInitialised, useArrows } = window.BAO.Carousel.plugins

class FilterCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.els?.slide?.selector || !this.els.slides.element) return

    this.carousel = this.setupCarousel()
  }

  disconnectedCallback () {
    super.disconnectedCallback()

    this.carousel?.destroy()
    this.carousel = null
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els?.slide?.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 'auto',
          spacing: 8,
        },
      },
      [
        setInitialised(),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }

  /**
   * Scrolls to the first available (non-disabled) slide on every filter
   * update. The caller skips this entirely when the update was triggered
   * by this same carousel's own checkboxes, so selecting a model doesn't
   * yank the carousel back to the start.
   */
  scrollToFirstAvailable () {
    if (!this.carousel) return

    const slides = this.els.slide.elements
    const firstAvailableIndex = slides.findIndex(
      (slide) =>
        !slide.querySelector('.clc-ProductGridFacet_Checkbox')?.disabled,
    )

    if (firstAvailableIndex !== -1) {
      this.carousel.moveToIdx(firstAvailableIndex)
    }
  }
}

if (!customElements.get('filter-carousel')) {
  customElements.define('filter-carousel', FilterCarousel)
}
